import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ApplicationContext } from '../../context/application_ctx'
import { IconButtonMA } from '../../styles/styledComponents';
import { Close, Delete, } from '@mui/icons-material';
import { theme } from '../../styles/theme';

export default function DeleteEmployeeDialog() {
    // context
    const { isOpenDeleteEmployeeDialog, setIsOpenDeleteEmployeeDialog, registerDetails } = useContext(ApplicationContext);


    // const [epId, setEpId] = useState("")
    const [epName, setEpName] = useState("")
    const [epEmail, setEpEmail] = useState("")
    const [epDesignation, setEpDesignation] = useState("")
    const [licenseStatus, setLicenseStatus] = useState("unallocated");

    function handleCloseRegisterDialog() {
        setIsOpenDeleteEmployeeDialog(false);
    }


    // async function handleDeleteDetail() {
    //     // if (!category || !description) {
    //     //     return;
    //     // }

    //     let tempArr = [...addRowEmp];

    //     tempArr.push({
    //         "epName": epName,
    //         "epEmail": epEmail,
    //         "epDesignation": epDesignation,
    //         "licenceStatus": licenseStatus
    //     })
    //     setAddRowEmp([...tempArr]);




    //     let tempArray = [...addRowEmp]

    //     let foundIndex = addRowEmp.findIndex((x) => x.epName === registerDetails?.epName && x.epDesignation === registerDetails?.epDesignation);


    //     // console.log(foundIndex, "foundIndex")

    //     tempArray.splice(foundIndex, 1);

    //     setAddRowEmp(tempArray)

    //     handleCloseRegisterDialog();

    //     return;



    //     // try {

    //     //     let body = {
    //     //         "epName": epName,
    //     //         "epEmail": epEmail,
    //     //         "epDesignation": epDesignation,
    //     //         "licenceStatus": licenseStatus
    //     //     }

    //     //     if (!category) {
    //     //         delete body[category]
    //     //     }

    //     //     if (!subCategory) {
    //     //         delete body[subCategory]
    //     //     }


    //     //     setLoading(true);


    //     //     let response = await createEventController(body);

    //     //     setLoading(false);
    //     //     console.log(response, "response");

    //     //     if (response.status === HttpStatusCode.Ok) {

    //     //         // setCategory("");
    //     //         // setDescription("");

    //     //         // update the category list
    //     //         // let tempArray = [...sub_IncidentDataList];
    //     //         // tempArray.push(response.data.data.saveIncidentData)

    //     //         // setincidentDataList(prev => [...prev, response.data.data.saveIncidentData]);

    //     //         // setSub_IncidentDataList(tempArray)

    //     //         // close dialog box
    //     //         // handleCloseCreateDialog();

    //     //     } else {
    //     //         // if any error message show the message to user
    //     //         if (typeof (response?.data?.message) === 'string' || (response?.data?.message) instanceof String) {

    //     //             // handleOpenSnackbar(response?.data?.message, SnackbarStatusType.warning);
    //     //         } else if (typeof (response?.data?.error) === 'string' || (response?.data?.error) instanceof String) {

    //     //             // handleOpenSnackbar(response?.data?.error, SnackbarStatusType.warning);
    //     //         } else if (typeof (response.data) === 'string' || (response.data) instanceof String) {

    //     //             // handleOpenSnackbar(response?.data, SnackbarStatusType.warning);
    //     //         }
    //     //     }
    //     // } catch (err) {
    //     //     console.log("Error in Create Event : ", err);
    //     // }

    // }

    useEffect(() => {
        setEpName(registerDetails.epName);
        setEpEmail(registerDetails.epEmail);
        setEpDesignation(registerDetails.epDesignation);
        setLicenseStatus(registerDetails.licenseStatus);
    }, [registerDetails]);

    return (
        <Dialog onClose={handleCloseRegisterDialog} open={isOpenDeleteEmployeeDialog}
            sx={{
                "& .MuiDialog-paper": {
                    minWidth: "40%",
                    //  minHeight: "60vh" 
                },
            }}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h4" color={theme.col_2}>Delete Employee</Typography>

                    <Box display="flex" alignItems="center" gap={2}>
                        <IconButtonMA disabled={
                            epName === "" ? true
                                : epEmail === "" ? true
                                    : epDesignation === "" ? true
                                        : licenseStatus === "" ? true
                                            : false
                        } size="small" onClick={handleCloseRegisterDialog}><Delete /></IconButtonMA>
                        <IconButtonMA size="small" onClick={handleCloseRegisterDialog}><Close /></IconButtonMA>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 1.5, }}>
                <Box py={0.8} px={1} display="flex" flexDirection="column" gap={2}>

                    <Typography variant="h6">Confirm you want to delete employee {registerDetails?.epName}</Typography>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
